import React from 'react'
import Sec1 from '../Sec1/Sec1'
import { Sec2 } from '../Sec2/Sec2'
import Sec3 from '../Sec3/Sec3'
import Sec4 from '../Sec4/Sec4'
import Sec5 from '../Sec5/Sec5'
import Sec6 from '../Sec6/Sec6'
import Sec7 from '../Sec7/Sec7'
import Sec31 from '../Sec3/Sec31';
import Sec62 from '../Sec6/Sec62'
const Home = () => {
  return (
    <div>
        <Sec1/>
        {/* <Sec2/>
        <Sec3/> */}
        {/* <Sec31/> */}
        {/* <Sec4/>
        <Sec5/>
        <Sec6/>
        <Sec7/> */}
    </div>
  )
}

export default Home;